module.exports = __webpack_public_path__ + "static/media/withdrawFunds.31b145cb.svg";